export type NormalizeUrlOptions = {
  /**
   * * Protocol to prefix when missing. Prefer https for safety.
   * * Example: "https://"
   */
  defaultProtocol?: 'https://' | 'http://';
};

/**
 * * Normalizes a user-entered URL-like value.
 *
 * * - Trims whitespace.
 * * - Preserves values that already start with http:// or https://
 * * - Converts protocol-relative URLs (//example.com) to https://example.com
 * * - Prefixes with defaultProtocol when missing.
 */
export function normalizeUrl(
  raw: string,
  options: NormalizeUrlOptions = {},
): string {
  const defaultProtocol = options.defaultProtocol ?? 'https://';
  const v = raw.trim();
  if (v === '') return v;

  if (/^https?:\/\//i.test(v)) return v;
  if (v.startsWith('//')) return `${defaultProtocol.replace('://', ':')}${v}`;

  return `${defaultProtocol}${v}`;
}
